import React, { useRef, useEffect, useState } from 'react';
import { Nav, Container } from 'react-bootstrap';
import './NavigationBar.scss';
import { history } from '../../redux/store';
import { ReactComponent as LogoLight } from '../../assets/logo-light.svg';
import { ReactComponent as LogoDark } from '../../assets/logo-dark.svg';
import { useSelector } from 'react-redux';

const WebNavigation = (props) => {
    const { menu, onChange } = props;
    const navRef = useRef();
    const [solidNav, setSolidNav] = useState(false);
    const route = useSelector(state => state.router)

    const onscrollAdjust = () => {
        let scrollPosition = window.scrollY;
        if (scrollPosition > 50) {
            setSolidNav(true);
        }
        else {
            setSolidNav(false);

        }
    };

    const onClickNavButton = () => {
        history.push('/career')
    }
    useEffect(() => {

        if (route.location.pathname === '/') {
            setSolidNav(false);
            window.addEventListener("scroll", onscrollAdjust);
            onChange(0)
        }
        else {
            setSolidNav(true)
            onChange(navRef.current.clientHeight)
            return window.removeEventListener("scroll", onscrollAdjust);
        }
    }, [route, onChange]);
    return (
        <Nav ref={navRef} className={`navbar-dark bg-transparent custom-navigation py-3 position-fixed align-items-center ${solidNav ? "solid-nav pt-3" : "pt-5"} `}>

            <Container className="d-flex justify-content-around navogation-inner">
                <a href="/" className="mr-5" onClick={(e) => {
                    e.preventDefault();
                    history.push('/')
                }}>
                    {solidNav ? (
                        <LogoDark />
                    ) : (
                        <LogoLight />
                    )}
                </a>
                <div className="navigation-right ml-5 ml-lg-auto align-items-center d-flex">
                    <Nav>
                        {menu && menu.map((m) => {
                            if (m.type === 'button') {
                                return (
                                    <Nav.Item key={m.path}>
                                        <Nav.Link
                                            className="button-style"
                                            onClick={() => {
                                                onClickNavButton();
                                            }}>
                                            {m.name}
                                        </Nav.Link>
                                    </Nav.Item>
                                )
                            }
                            else {
                                return (
                                    <Nav.Item key={m.path} className="parent-navigation">
                                        <Nav.Link className="parent-menu">

                                            <span
                                                onClick={() => {
                                                    history.push(m.path)
                                                }}
                                            >
                                                {m.name}
                                            </span>
                                            {m.child &&
                                                <div className="child-menu-wrapper">
                                                    <ul key={m.child} className="child-menu">
                                                        {m.child.map((menu, index) => {
                                                            return (
                                                                <li key={index} className="child-section">
                                                                    {/* <span>{menu.title}</span> */}
                                                                    {menu.child &&
                                                                        <ul className="child-items">
                                                                            {menu.child.map((cm, index) => {
                                                                                return (
                                                                                    <li key={index} className="child-item">
                                                                                        <a href={cm.path} onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            history.push(cm.path)
                                                                                        }}>
                                                                                            {cm.title}
                                                                                        </a>
                                                                                        {cm?.child && <ul style={{ paddingLeft: 15, borderLeft: '1px solid #e0e0e0', marginTop: 5 }}>
                                                                                            {cm.child && cm.child.map((c, index) => {
                                                                                                return <li key={index} className="child-item" style={{ paddingTop: 5, paddingBottom: 5 }}>
                                                                                                    <a href={c.path} onClick={(e) => {
                                                                                                        e.preventDefault();
                                                                                                        history.push(c.path)
                                                                                                    }}>
                                                                                                        {c.title}
                                                                                                    </a>
                                                                                                </li>
                                                                                            })}
                                                                                        </ul>}
                                                                                    </li>
                                                                                )
                                                                            })}
                                                                        </ul>
                                                                    }
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>
                                            }
                                        </Nav.Link>
                                    </Nav.Item>
                                )
                            }
                        })}
                    </Nav>
                </div>
            </Container>
        </Nav>
    )
}

export default WebNavigation;